var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    width: 130.583,
    height: 87.9271,
    rx: 11.5157,
    fill: "#E8F7E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8299 59.4673C58.8299 59.4673 56.6171 60.754 60.4047 61.1895C64.9933 61.7129 67.3384 61.6379 72.3951 60.6808C72.3951 60.6808 73.7246 61.5144 75.5811 62.2365C64.2456 67.0947 49.9262 61.955 58.8299 59.4673ZM57.4447 53.1274C57.4447 53.1274 54.9628 54.9646 58.7533 55.3566C63.6549 55.8623 67.5258 55.9037 74.2241 54.6139C74.2241 54.6139 75.1506 55.5531 76.6073 56.0668C62.9018 60.0745 47.6363 56.3829 57.4447 53.1274Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1234 42.3728C71.9166 45.5885 68.3896 48.4823 68.3896 48.4823C68.3896 48.4823 75.4817 44.8212 72.2246 40.2364C69.1826 35.9611 66.8496 33.8365 79.4788 26.5122C79.4788 26.5122 59.6553 31.4633 69.1234 42.3728Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1148 64.1562C84.1148 64.1562 85.7523 65.5053 82.3113 66.5492C75.7683 68.5314 55.0782 69.1299 49.3306 66.6282C47.2645 65.7295 51.1391 64.4821 52.3578 64.2202C53.6288 63.9446 54.3553 63.9961 54.3553 63.9961C52.0575 62.3773 39.5036 67.1744 47.9786 68.548C71.0908 72.2962 90.1098 66.8604 84.1148 64.1562ZM59.8942 46.5584C59.8942 46.5584 49.3701 49.0582 56.1675 49.9658C59.0375 50.35 64.7588 50.2632 70.0882 49.8166C74.4436 49.4494 78.817 48.6681 78.817 48.6681C78.817 48.6681 77.2812 49.3258 76.1702 50.0845C65.4829 52.8953 44.8372 51.5877 50.7808 48.7125C55.8074 46.2828 59.8942 46.5584 59.8942 46.5584ZM78.7736 57.1112C89.6378 51.4658 84.6146 46.0407 81.1085 46.7717C80.2491 46.9504 79.866 47.1054 79.866 47.1054C79.866 47.1054 80.1851 46.6057 80.7943 46.3895C87.7304 43.9509 93.0647 53.5815 78.5553 57.3957C78.5553 57.3959 78.7234 57.2457 78.7736 57.1112Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2244 14.6852C72.2244 14.6852 78.2411 20.7042 66.5178 29.9591C57.117 37.3833 64.3741 41.6163 66.5139 46.4528C61.0265 41.5018 56.9993 37.1434 59.7011 33.0871C63.6664 27.1323 74.6519 24.2456 72.2244 14.6852Z",
    fill: "#E76F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9619 72.4092C71.39 73.0768 87.4036 72.0388 87.7828 67.1045C87.7828 67.1045 87.0538 68.9752 79.1645 70.4607C70.2639 72.1356 59.2863 71.9401 52.7753 70.8666C52.7754 70.8666 54.108 71.9698 60.9619 72.4092Z",
    fill: "#5382A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.9205,
    height: 58.0098,
    fill: "white",
    transform: "translate(44.9893 14.623)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg16);
export default __webpack_public_path__ + "static/media/fet-img (16).64c76cb51a63d3ca742f11792b774aff.svg";
export { ForwardRef as ReactComponent };